import React from 'react'
import Badge from '@mui/material/Badge'
import { styled } from '@mui/material/styles'

interface CardHotkeyBadgeProps {
  hotkey?: string
}

const StyledCardHotkeyBadge = styled(Badge)(({ theme }) => ({
  '.MuiBadge-badge': {
    pointerEvents: 'none',
    opacity: 0.9,
    borderRadius: '4px',
    backgroundColor: theme.palette.grey[400],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  '.MuiBadge-anchorOriginBottomRight': {
    right: '50%',
  },
}))

export const CardHotkeyBadge: React.FC<React.PropsWithChildren<CardHotkeyBadgeProps>> = ({ hotkey, children }) => (
  <StyledCardHotkeyBadge
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    badgeContent={hotkey?.toUpperCase()}
  >
    {children}
  </StyledCardHotkeyBadge>
)
